$(function(){
    $.fn.myArcCanvas=function(lastPoint,timeHandler,eventHandler,offset){
            var thMain=$(this);
            var timeLast= (new Date()).getTime();

            var running_index=timeHandler.getNewIndex(),step_mili=30;
            var clear_index=timeHandler.getNewIndex(),clear_is=0;
            var point_index=timeHandler.getNewIndex();
            var clearPoint_index=timeHandler.getNewIndex();

            var canvas,ctx;
            var mouseX,mouseY,mouseDown=0;
            var touchX,touchY;
            var pointsArr=[];
            var wasTrigger=0;
//            var lastPoint=[];
            var pointSet=[];
            
            function putPoint(x,y) {
                
                lastPoint.splice(0,lastPoint.length);
                lastPoint.unshift(x,y);

                timeHandler.clear(point_index);
                timeHandler.setOne(point_index,function(){
                    lastPoint.splice(0,lastPoint.length);// same as, reference  lastPoint=[];
                },100);

                var last_milisec=2000;
                if(!timeHandler.isIndexSet(running_index) && clear_is==0){
                    timeHandler.setOne(running_index,function(){
                        //just block
                    },step_mili);
                    pointsArr.push([x,y]);
                    
                    
                    
                    if(!wasTrigger){
                        wasTrigger=1;
                        thMain.trigger("firstPoint");
                    }
                    if(pointsArr.length>last_milisec/step_mili){
                        pointsArr.shift();
                    }
                    drawArc();
                }

            } 
            function drawIt(ctx,x,y,size,color){
                if(!color){
                    color=[0,0,0,1];
                }
                ctx.fillStyle = "rgba("+color.join(",")+")";
                ctx.beginPath();
                ctx.arc(x, y, size, 0, Math.PI*2, true); 
                ctx.closePath();
                ctx.fill();
            }

            // Clear the canvas context using the canvas width and height
            function clear() {
                if(clear_is==0){
                    var pointsOld= copyArray(pointsArr);
                    pointsArr=[];
                    timeHandler.clear(clear_index);
                    clear_is=1;
                    var step=3;
                     timeHandler.set(clear_index,function(){
                        if(!clear_is || step<1){
                            timeHandler.clear(clear_index);
                            clearCanvas();
                            clear_is=0;
                        }
                        else{

                            step--;
                            drawArc(pointsOld,step,1);
                        }
                    },50);
                }
            }


            function sketchpad_mouseDown() {
                clear_is=0;
                mouseDown=1;
                pointsArr=[];
                putPoint(mouseX,mouseY);
            }

            function sketchpad_mouseUp() {
                mouseDown=0;
                clear();
            }

            function sketchpad_mouseMove(e) { 
                getMousePos(e);
                if (mouseDown==1) {
                    putPoint(mouseX,mouseY);
//                    drawIt(ctx,mouseX,mouseY,5,[255,0,0,1]);
                }
                
            }

            function getMousePos(e) {
                if (!e){
                    e = event;
                }

                if (e.offsetX) {
                    mouseX = e.offsetX;
                    mouseY = e.offsetY;
                }
                else if (e.layerX) {
                    mouseX = e.layerX;
                    mouseY = e.layerY;
                }
             }

            function sketchpad_touchStart(e) {
                if (!e){
                    e = event;
                }
                clear_is=0;
                getTouchPos(e);
                pointsArr=[];
                putPoint(touchX,touchY);
                e.preventDefault();
            }

            function sketchpad_touchMove(e) { 
                if (!e){
                    e = event;
                }
                getTouchPos(e);
                 
                
                putPoint(touchX,touchY); 
                
                e.preventDefault();
            }

            function sketchpad_touchEnd(e) { 
                clear();
              }

            function getTouchPos(e) {
                if (!e){
                    e = event;
                }

                if(e.touches) {
                    if (e.touches.length == 1) { // Only deal with one finger
                        var touch = e.touches[0]; // Get the information for finger #1
                        var off=$(touch.target).offset(),scale_top=1;
                        var offObj=$.takeScaleObj();
                        scale_top=1/offObj.scale;

    //                    if(typeof offset!="undefined"){
    //                        var offObj=$.takeScaleObj();
    //                        off=copyObj(offset);
    //                        off.top+=offObj.space;
    //                        off.left+=(offObj.body[0]-offObj.full_min[0])/2;
    //                        scale_top=offObj.scale;
    //                    }
    //                    else{
    //                         debugArr(off);
    //                    }
                        touchX=(touch.pageX-off.left)*scale_top;
                        touchY=(touch.pageY-off.top)*scale_top;
                    }
                }
            }
            function clearCanvas(){
                ctx.clearRect(0, 0, canvas.width, canvas.height);
            }
            function clearPoints(){
                timeHandler.clear(clearPoint_index);
                timeHandler.setOne(clearPoint_index,function(){
                    pointSet.splice(0,pointSet.length);
                },50);
                
            }
            function drawArc(points_use,howmany_draw,to_del){
                
                
                if(typeof to_del==="undefined"){
                    to_del=1;
                }
                if(typeof howmany_draw==="undefined"){
                    howmany_draw=2;
                }
                if(typeof points_use==="undefined"){
                    points_use=pointsArr;
                }
                var points=copyArray(points_use);
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                if(typeof points=="object"){
                    var len=points.length,i,i_max,k_max,arr,point,distance;
                    if(len>=2){
                        if(!to_del && !isEqualVectors(lastPoint,points[points.length-1])){
                            points.push(lastPoint);
                            len=points.length;
                        }
                        var objSm=new Smooth(points);
                        
                        var start_point=0,need_points=5;
                        start_point=Math.max(0,len-need_points);
                        
                        var pointSetTmp=[];
                        
                       
                        for(point=start_point;point<=len-2;point++){
                            distance=Math.sqrt(Math.pow(points[point][0]-points[point+1][0],2)+Math.pow(points[point][1]-points[point+1][1],2));
                            i_max=Math.round(distance/2);
                            i_max=Math.max(i_max,3);
                            for(i=0;i<=i_max;i++){
                                arr=objSm(i/i_max+point);
                                drawIt(ctx,arr[0],arr[1],5,[255,255,255,0.23]);
                            }
                            if(point==len-2){
                                drawIt(ctx,lastPoint[0],lastPoint[1],5,[255,255,255,0.23]);
                            }
//                            if(point>=len-2){
//                                k_max=Math.round(distance/8);
//                                for(i=0;i<=k_max;i++){
//                                    arr=objSm(i/(k_max+1)+point);
//                                    arr[0]=Math.round(arr[0]);
//                                    arr[1]=Math.round(arr[1]);
//                                    pointSetTmp.push([arr[0],arr[1]]);
//                                    drawIt(ctx,arr[0],arr[1],5,[255,0,0,1]);
//                                }
//                            }
                            
//                            if(point==len-2){
//                                arr=objSm(len-1);
//                                
//                                drawIt(ctx,arr[0],arr[1],5,[255,255,255,0.23]);
//                                arr[0]=Math.round(arr[0]);
//                                arr[1]=Math.round(arr[1]);
//                                pointSetTmp.push([Math.round(arr[0]),Math.round(arr[1])]);
//                                drawIt(ctx,arr[0],arr[1],5,[255,0,0,1]);
//                            }
                        }
//                        console.log("start");
//                        console.log(tt);
//                        console.log(points.slice(start_point));
//                        console.log(pointSetTmp);
                        
                        pointSet.splice(0,pointSet.length)
                        for(i in pointSetTmp){
                            pointSet.push(pointSetTmp[i]);
                        }
                        clearPoints();
                        
                        
                        
                        
                        
                        
//                        for(point=Math.max(len-howmany_draw-2,0);point<=len-2;point++){
//                            i_max=Math.sqrt(Math.pow(points[point][0]-points[point+1][0],2)+Math.pow(points[point][1]-points[point+1][1],2));
//                            i_max=Math.round(i_max/2);
//                            i_max=Math.max(i_max,3);
//
//                            for(i=0;i<=i_max;i++){
//                                arr=objSm(i/i_max+point);
//                                drawIt(ctx,arr[0],arr[1],5,[255,255,255,0.23]);
//                            }
//                        }
//                        drawIt(ctx,lastPoint[0],lastPoint[1],5,[255,255,255,1]);
                    }
                }
                
//                if(lastPoint.length==2){
//                    pointSet.splice(0,pointSet.length,[lastPoint[0],lastPoint[1]]);
//                    lastPoint=[];
//                }
                
            }

            function init() {
                canvas = thMain[0];
                if (canvas.getContext){
                    ctx = canvas.getContext('2d');
                }
                if (ctx) {
                    canvas.addEventListener('mousedown',
                        function(event){
                            sketchpad_mouseDown(event);
                            return false;
                        }
                    , false);
                    canvas.addEventListener('mousemove',
                        function(event){
                            sketchpad_mouseMove(event);
                            return false;
                        }, 
                    false);
                    eventHandler.on("mouseupAll",function(event){
                        sketchpad_mouseUp(event);
                        return false;
                    });
                    canvas.addEventListener('touchstart',
                        function(event){
                           sketchpad_touchStart(event);
                           return false;
                        }, 
                    false);
                    canvas.addEventListener('touchmove', 
                        function(event){
                            sketchpad_touchMove(event);
                            return false;
                        }

                    , false);
                    canvas.addEventListener('touchend', 
                        function(event){
                            sketchpad_touchEnd(event);
                            return false;
                        }
                    , false);
                }
                
                
                
            }
            init();
    };
});